import React, { useState } from 'react';
import { useGetAvailableLanguages } from '../../../hooks/global/Languages';

const LangSelect = ({value = null, onSelect = null}) => {
  const availableLanguages = useGetAvailableLanguages();

  // Set the initial selected language to the first in the list
  const [selected, setSelected] = useState(value || availableLanguages[0]);

  // Handle language selection
  const handleLangClick = (lang) => {
    setSelected(lang);
    onSelect?.(lang);
  };

  return (
    <div className="btn-group" role="group" aria-label="">
      {availableLanguages.map((lang, index) => (
        <React.Fragment key={lang}>
          <input
            type="radio"
            className='btn-check'
            name="btnradio"
            id={`btnradio-${index}`} // Unique id for each radio input
            autoComplete="off"
            checked={selected === lang}
            onChange={() => handleLangClick(lang)}
          />
          <label
            className={`btn radio-btn ${selected === lang ? 'active' : ''}`}
            htmlFor={`btnradio-${index}`}
          >
            {lang}
          </label>
        </React.Fragment>
      ))}
    </div>
  );
};

export default LangSelect;
